import { CommonWorkflowService } from '@savgroup-front-common/core/api';

import addUnexpectedProductsCommand from '@/api/Workflow/addUnexpectedProductsCommand';
import cancelReportFraudCommand from '@/api/Workflow/cancelReportFraudCommand';
import createCaseIfNotExistCommand from '@/api/Workflow/createCaseIfNotExistCommand';
import { createWorkflowVersionCommand } from '@/api/Workflow/createWorkflowVersionCommand';
import createWorkOrderCommand from '@/api/Workflow/createWorkOrderCommand';
import { addExternalCarrierDepositLabelCommand } from '@/api/Workflow/files/addExternalCarrierDepositLabelCommand';
import addExternalCarrierTrackingReferenceCommand from '@/api/Workflow/files/addExternalCarrierTrackingReferenceCommand';
import assignFileToUserCommand from '@/api/Workflow/files/assignFileToUserCommand';
import cancelTechnicalIntervention from '@/api/Workflow/files/cancelTechnicalIntervention';
import changeStoreActor from '@/api/Workflow/files/changeStoreActor';
import { createFileAttachmentFromControlCommand } from '@/api/Workflow/files/createFileAttachmentFromControlCommand';
import explodeFileCommand from '@/api/Workflow/files/explodeFileCommand';
import { getClosedFilesByOrderId } from '@/api/Workflow/files/getClosedFilesByOrderId';
import { getCustomerFileFullSummaryQuery } from '@/api/Workflow/files/getCustomerFileFullSummaryQuery';
import { getCustomerFilesFullSummariesQuery } from '@/api/Workflow/files/getCustomerFilesFullSummariesQuery';
import { getFileAdditionalInformation } from '@/api/Workflow/files/getFileAdditionalInformation';
import getFileByReference from '@/api/Workflow/files/getFileByReference';
import { getFileCommentListQuery } from '@/api/Workflow/files/getFileCommentListQuery';
import getFileProductAdequaciesQuery from '@/api/Workflow/files/getFileProductAdequaciesQuery';
import { getFileReactionsQuery } from '@/api/Workflow/files/getFileReactionsQuery';
import getFileStatusVisibilitiesQuery from '@/api/Workflow/files/getFileStatusVisibilitiesQuery';
import { getLatestFilesByOrderId } from '@/api/Workflow/files/getLatestFilesByOrderId';
import { getOpenedFilesByOrderId } from '@/api/Workflow/files/getOpenedFilesByOrderId';
import reScheduleTechnicalInterventionCommand from '@/api/Workflow/files/reScheduleTechnicalInterventionCommand';
import setActorCommand from '@/api/Workflow/files/setActorCommand';
import { setFileAdditionalInformation } from '@/api/Workflow/files/setFileAdditionalInformation';
import { setFileAdditionalInformationWithFilesCommand } from '@/api/Workflow/files/setFileAdditionalInformationWithFilesCommand';
import setFileProductAdequacyCommand from '@/api/Workflow/files/setFileProductAdequacyCommand';
import setNewWorkflowVersion from '@/api/Workflow/files/setNewWorkflowVersion';
import unassignFileCommand from '@/api/Workflow/files/unassignFileCommand';
import { updateDepositStoreCommand } from '@/api/Workflow/files/updateDepositStoreCommand';
import updateFileAddress from '@/api/Workflow/files/updateFileAddress';
import { updateFileOwnerNotificationCommand } from '@/api/Workflow/files/updateFileOwnerNotificationCommand';
import updateStoreActorCommand from '@/api/Workflow/files/updateStoreActorCommand';
import { upsertModuleDefinitionLocalesCommand } from '@/api/Workflow/files/upsertModuleDefinitionLocalesCommand';
import forceCloseFilesCommand from '@/api/Workflow/forceCloseFilesCommand';
import { getAdvancedHistoryQuery } from '@/api/Workflow/getAdvancedHistoryQuery';
import getAllowedCustomActionWorkflowQuery from '@/api/Workflow/getAllowedCustomActionWorkflowQuery';
import getAllWorkflowQuery from '@/api/Workflow/getAllWorkflowQuery';
import getFileFraudScoreQuery from '@/api/Workflow/getFileFraudScoreQuery';
import getFileFraudStatusQuery from '@/api/Workflow/getFileFraudStatusQuery';
import { getFileMessagesQuery } from '@/api/Workflow/getFileMessagesQuery';
import getFilesByRefFromFileCommand from '@/api/Workflow/getFilesByRefFromFileCommand';
import { getFileSellerActorsQuery } from '@/api/Workflow/getFileSellerActorsQuery';
import getFilesForProductsCommand from '@/api/Workflow/getFilesForProductsCommand';
import { getHistoricFileInfo } from '@/api/Workflow/getHistoricFileInfo';
import { getHistoricFileList } from '@/api/Workflow/getHistoricFileList';
import { getHistoryItemsQuery } from '@/api/Workflow/getHistoryItemsQuery';
import getIsAnyFileCreatedByOwnerQuery from '@/api/Workflow/getIsAnyFileCreatedByOwnerQuery';
import getLastWorkflowVersion from '@/api/Workflow/getLastWorkflowVersion';
import getMatchingActorsQuery from '@/api/Workflow/getMatchingActorsQuery';
import getModelSafetyriskFile from '@/api/Workflow/getModelSafetyriskFile';
import getOpenedFilesQuery from '@/api/Workflow/getOpenedFilesQuery';
import { getOwnersWithOpenFileQuery } from '@/api/Workflow/getOwnersWithOpenFileQuery';
import getProductAdequaciesQuery from '@/api/Workflow/getProductAdequaciesQuery';
import getProductHistoryByOwnerProductId from '@/api/Workflow/getProductHistoryByOwnerProductId';
import getProductOrientationsQuery from '@/api/Workflow/getProductOrientationsQuery';
import getRefundPolicyQuery from '@/api/Workflow/getRefundPolicyQuery';
import getWorkTypeBySellerQuery from '@/api/Workflow/getWorkTypeBySellerQuery';
import instanciateCommercialGestureModuleCommand from '@/api/Workflow/instanciateCommercialGestureModuleCommand';
import instanciatePaymentRefundModuleCommand from '@/api/Workflow/instanciatePaymentRefundModuleCommand';
import removeUnexpectedProductCommand from '@/api/Workflow/removeUnexpectedProductCommand';
import reportFraudCommand from '@/api/Workflow/reportFraudCommand';
import { sendFileMessageCommand } from '@/api/Workflow/sendFileMessageCommand';
import setAdditionalInformationFactoryCode from '@/api/Workflow/setAdditionalInformationFactoryCode';
import setCustomStateKeyValueCommand from '@/api/Workflow/setCustomStateKeyValueCommand';
import setDetailedCommercialGestureCommand from '@/api/Workflow/setDetailedCommercialGestureCommand';
import setDetailedCommercialSolutionCommand from '@/api/Workflow/setDetailedCommercialSolutionCommand';
import setFileAdditionalInformationCommand from '@/api/Workflow/setFileAdditionalInformationCommand';
import setModelSafetyriskFile from '@/api/Workflow/setModelSafetyriskFile';
import updateFileSolutionCommand from '@/api/Workflow/updateFileSolutionCommand';
import { updateRequestStatusCommand } from '@/api/Workflow/updateRequestStatusCommand';
import updateWarrantyCommand from '@/api/Workflow/updateWarrantyCommand';
import { createWorkflowVersionWithDesignerFileCommand } from '@/api/Workflow/workflows/createWorkflowVersionWithDesignerFileCommand';

export const WorkflowService = {
  getHistoryItemsQuery,
  getAdvancedHistoryQuery,
  getFileReactionsQuery,
  updateDepositStoreCommand,
  updateFileOwnerNotificationCommand,
  upsertModuleDefinitionLocalesCommand,
  createWorkflowVersionCommand,
  addExternalCarrierDepositLabelCommand,
  createFileAttachmentFromControlCommand,
  assignFileToUserCommand,
  unassignFileCommand,
  setFileProductAdequacyCommand,
  changeStoreActor,
  updateStoreActorCommand,
  getProductOrientationsQuery,
  getCustomerFileFullSummaryQuery,
  getCustomerFilesFullSummariesQuery,
  deleteFileAttachmentCommand:
    CommonWorkflowService.deleteFileAttachmentCommand,
  renameFileAttachmentCommand:
    CommonWorkflowService.renameFileAttachmentCommand,
  createCaseIfNotExistCommand,
  getWorkTypeBySellerQuery,
  getProductHistoryByOwnerProductId,
  getOpenedFilesQuery,
  getLastWorkflowVersion,
  createWorkOrderCommand,
  getClosedFilesByOrderId,
  getFileAdditionalInformation,
  getFileByReference,
  getFileHandling: CommonWorkflowService.getFileHandling,
  getFileRiskCarrier: CommonWorkflowService.getFileRiskCarrier,
  getLatestFilesByOrderId,
  getOpenedFilesByOrderId,
  setFileAdditionalInformation,
  updateFileAddress,
  setNewWorkflowVersion,
  setFileAttachmentInfo: CommonWorkflowService.setFileAttachmentInfo,
  setActorCommand,
  reScheduleTechnicalInterventionCommand,
  cancelTechnicalIntervention,
  addExternalCarrierTrackingReferenceCommand,
  getFileStatusVisibilitiesQuery,
  getModelSafetyriskFile,
  setModelSafetyriskFile,
  createFileAttachmentsFromControlCommand:
    CommonWorkflowService.createFileAttachmentsFromControlCommand,
  getHistoricFileInfo,
  getHistoricFileList,
  updateWarrantyCommand,
  addUnexpectedProductsCommand,
  removeUnexpectedProductCommand,
  updateRequestStatusCommand,
  getFileSellerActorsQuery,
  getRefundPolicyQuery,
  setDetailedCommercialSolutionCommand,
  updateFileSolutionCommand,
  instanciatePaymentRefundModuleCommand,
  forceCloseFilesCommand,
  instanciateCommercialGestureModuleCommand,
  setDetailedCommercialGestureCommand,
  setFileAdditionalInformationCommand,
  setAdditionalInformationFactoryCode,
  getOwnersWithOpenFileQuery,
  setFileAdditionalInformationWithFilesCommand,
  getIsAnyFileCreatedByOwnerQuery,
  getProductAdequaciesQuery,
  getFileProductAdequaciesQuery,

  createWorkflowVersionWithDesignerFileCommand,
  setCustomStateKeyValueCommand,
  getMatchingActorsQuery,
  getFilesForProductsCommand,
  getFilesByRefFromFileCommand,
  getAllowedCustomActionWorkflowQuery,
  getFileFraudScoreQuery,
  getFileFraudStatusQuery,
  reportFraudCommand,
  cancelReportFraudCommand,

  explodeFileCommand,
  getAllWorkflowQuery,

  getFileCommentListQuery,
  getFileMessagesQuery,
  sendFileMessageCommand,
};
